import React, { useState, useEffect } from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Up, Down, Left, Right } from "../components/PositionFade";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useSpring, useSprings, useScroll, animated } from "@react-spring/web";
import { useNavigate } from "react-router";
import {
  LeftInView,
  RightInView,
  UpInView,
  DownInView,
} from "./PositionFadeInView";
import TextField from "@mui/material/TextField";

import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";
import { useDispatch } from "react-redux";
import axios from "axios";
import { API_URL } from "../actions/auth";
import { alertMessage } from "../actions/auth";

const config = {
  duration: 500,
};

export function SpacerV(props) {
  return (
    <div
      style={{ height: props.height, width: "100%", backgroundColor: "white" }}
    />
  );
}

export function SpacerH(props) {
  return (
    <div
      style={{ width: props.width, height: "100%", backgroundColor: "white" }}
    />
  );
}

export function CardHorizontal(props) {
  const [menuContainer, menuContainerApi] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));
  const navigate = useNavigate();

  return (
    <animated.div
      style={{
        padding: "10px",
        paddingLeft: "15px",
        borderRadius: "5px",
        width: "100%",
        backgroundColor: "white",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        cursor: "pointer",
        transform: "scale(1)",
        ...menuContainer,
      }}
      onClick={() => {
        navigate("/" + props.navigate);
      }}
      onMouseEnter={() => {
        menuContainerApi.start({
          from: {
            transform: "scale(1)",
          },
          to: {
            transform: "scale(1.05)",
          },
        });
      }}
      onMouseLeave={() => {
        menuContainerApi.start({
          from: {
            transform: "scale(1.05)",
          },
          to: {
            transform: "scale(1)",
          },
        });
      }}
    >
      <div style={{ marginTop: "5px" }}>{props.content}</div>
      <div>
        <div
          style={{
            textAlign: "left",
            marginLeft: "15px",
            borderRadius: "25px",
            fontSize: "18px",
            color: "black",
            fontWeight: 600,
          }}
        >
          {props.title}
        </div>
        {/* <div
          style={{
            marginTop: "-5px",
            marginLeft: "15px",
            borderRadius: "25px",
            fontSize: "18px",
            color: "#222222",
            textAlign: "left",
          }}
        >
          {props.subtitle}
        </div> */}
      </div>
    </animated.div>
  );
}

export function Hero(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const dispatch = useDispatch();

  function onSubmit(e) {
    e.preventDefault();
    var body = {};
    body["name"] = name;
    body["email"] = email;
    body["phone_number"] = phoneNumber;
    body["subject"] = subject;
    body["description"] = description;

    axios
      .post(API_URL + "add_contact", JSON.stringify(body))
      .then((res) => {
        setName("");
        setEmail("");
        setPhoneNumber("");
        setDescription("");
        setSubject("");

        dispatch(
          alertMessage(
            "SUCCESS",
            "SUCCESS",
            "Your request has been submitted. Our team will get back to you."
          )
        );
      })
      .catch((err) => { });
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        background: props.background,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "100px",
        ...props.style,
      }}
    >
      <div
        className="content"
        style={{
          position: "absolute",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100vw",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "75vw",
          }}
        >
          <Grid container>
            <Grid
              item
              md={8}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <Up delay={timelineDelays[0]}>
                <div
                  style={{
                    width: state.auth.isMobile ? "100%" : "90%",
                    marginTop: state.auth.isMobile ? "-75px" : "0px",
                    fontSize: state.auth.isMobile ? "40px" : "65px",
                    fontWeight: "500",
                    lineHeight: state.auth.isMobile ? "45px" : "65px",
                    color: "white",
                    zIndex: 999,
                    marginBottom: "15px",
                  }}
                >
                  {props.title}
                </div>
              </Up>
              <Up delay={timelineDelays[1]}>
                <div
                  style={{
                    width: "90%",
                    fontSize: "18px",
                    color: "white",
                    zIndex: 999,
                  }}
                >
                  {props.subtitle}
                </div>
              </Up>
            </Grid>
            {!state.auth.isMobile ? (
              <Grid
                item
                md={4}
                xs={12}
                sm={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <Up delay={timelineDelays[2]}>
                  {" "}
                  <form
                    style={{
                      backdropFilter: "blur(5px)",
                      padding: "25px",
                      borderRadius: "5px",
                      backgroundColor: "rgba(255,255,255,0.5)",
                    }}
                    onSubmit={onSubmit}
                  >
                    <div
                      style={{
                        width: "100%",
                        fontSize: state.auth.isMobile ? "60px" : "25px",
                        fontWeight: "600",
                        lineHeight: "55px",
                        color: themeStyle.primaryColor,
                        textAlign: "center",
                        zIndex: 999,
                      }}
                    >
                      Contact Us
                    </div>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                        {
                          color: themeStyle.primaryColor,
                          fontWeight: 600,
                          opacity: 1,
                        },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="name"
                      autoComplete="name"
                      autoFocus
                      placeholder="Name *"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                        {
                          color: themeStyle.primaryColor,
                          fontWeight: 600,
                          opacity: 1,
                        },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      placeholder="E-mail *"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                        {
                          color: themeStyle.primaryColor,
                          fontWeight: 600,
                          opacity: 1,
                        },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="phonenumber"
                      autoComplete="phonenumber"
                      autoFocus
                      placeholder="Phone number *"
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        height: "400",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                        {
                          color: themeStyle.primaryColor,
                          fontWeight: 600,
                          opacity: 1,
                        },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="description"
                      autoComplete="description"
                      multiline
                      rows={4}
                      autoFocus
                      placeholder="Description of your enquiry *"
                      value={description}
                      onChange={(e) => {
                        setDescription(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <Button
                        style={{
                          width: "100%",
                          height: "50px",
                          backgroundColor:
                            state.auth.theme == "dark"
                              ? themeStyleDark.primaryButtonColor
                              : themeStyle.primaryButtonColor,
                          color:
                            state.auth.theme == "dark"
                              ? themeStyleDark.primaryButtonTextColor
                              : themeStyle.primaryButtonTextColor,
                        }}
                        type="submit"
                        variant="contained"
                      >
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: 600,
                          }}
                        >
                          SUBMIT REQUEST
                        </span>
                      </Button>
                    </div>
                  </form>
                </Up>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </div>
      </div>
    </div>
  );
}

export function ContentSideBySide(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        minHeight: "60vh",
        width: "100vw",
        paddingTop: "75px",
        background: "white",
        marginTop: state.auth.isMobile ? "-200px" : 0,
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid container spacing={10}>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
              }}
            >
              <RightInView delay={timelineDelays[0]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: state.auth.isMobile ? "30px" : "40px",
                    color: "black",
                    fontWeight: 600,
                    lineHeight: "60px",
                    paddingLeft: "15px",
                  }}
                >
                  {props.title}
                </div>
              </RightInView>
              <div
                style={{
                  margin: "15px 0px 25px 15px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: themeStyle.primaryColor,
                }}
              ></div>
              <RightInView delay={timelineDelays[1]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: "18px",
                    color: "black",
                    paddingLeft: "15px",
                    textAlign: state.auth.isMobile ? "left" : "justify",
                    fontWeight: 500,
                  }}
                >
                  {props.subtitle}
                </div>
              </RightInView>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
              }}
            >
              <RightInView delay={timelineDelays[2]}>{props.image}</RightInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function ContentSideBySideCustomInv(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        paddingTop: "75px",
        background: props.background,
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid
            container
            spacing={10}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
              }}
            >
              <RightInView delay={timelineDelays[2]}>{props.image}</RightInView>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
              }}
            >
              <RightInView delay={timelineDelays[0]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize:
                      props.titleFontSize == null
                        ? "60px"
                        : props.titleFontSize,
                    color:
                      props.titleColor == null ? "black" : props.titleColor,
                    fontWeight: 600,
                    lineHeight: "60px",
                    paddingLeft: "15px",
                  }}
                >
                  {props.title}
                </div>
              </RightInView>
              <div
                style={{
                  margin: "15px 0px 50px 0px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: themeStyle.primaryColor,
                }}
              ></div>
              <RightInView delay={timelineDelays[1]}>
                <div
                  style={{
                    fontWeight: 500,
                    borderRadius: "25px",
                    fontSize:
                      props.subtitleFontSize == null
                        ? "18px"
                        : props.subtitleFontSize,
                    color:
                      props.subtitleColor == null
                        ? "grey"
                        : props.subtitleColor,
                    paddingLeft: "15px",
                  }}
                >
                  {props.subtitle}
                </div>
              </RightInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function ContentSideBySideCustom(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        paddingTop: "75px",
        background: props.background,
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid
            container
            spacing={10}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "80%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
              }}
            >
              <RightInView delay={timelineDelays[0]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize:
                      props.titleFontSize == null
                        ? "30px"
                        : props.titleFontSize,
                    color:
                      props.titleColor == null ? "black" : props.titleColor,
                    fontWeight: 600,
                    lineHeight: "45px",
                    paddingLeft: "15px",
                  }}
                >
                  {props.title}
                </div>
              </RightInView>
              <div
                style={{
                  margin: "15px 0px 50px 15px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: themeStyle.primaryColor,
                  paddingLeft: "15px",
                }}
              ></div>
              <RightInView delay={timelineDelays[1]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize:
                      props.subtitleFontSize == null
                        ? "18px"
                        : props.subtitleFontSize,
                    color:
                      props.subtitleColor == null
                        ? "grey"
                        : props.subtitleColor,
                    paddingLeft: "15px",
                    textAlign: state.auth.isMobile ? "left" : "justify",
                    fontWeight: 500,
                  }}
                >
                  {props.subtitle}
                </div>
              </RightInView>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "80%",
                textAlign: "left",
              }}
            >
              <RightInView delay={timelineDelays[2]}>{props.image}</RightInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function ContentSideBySideInv(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        minHeight: "60vh",
        width: "100vw",
        paddingTop: "75px",
        background: "white",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid container spacing={5}>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
              }}
            >
              <RightInView delay={timelineDelays[0]}>{props.image}</RightInView>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
              }}
            >
              <RightInView delay={timelineDelays[1]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: state.auth.isMobile ? "30px" : "40px",
                    color: "black",
                    fontWeight: 600,
                    lineHeight: state.auth.isMobile ? "60px" : "60px",
                    paddingLeft: "15px",
                  }}
                >
                  {props.title}
                </div>
              </RightInView>
              <div
                style={{
                  margin: "10px 0px 25px 15px",
                  width: "60px",
                  height: "5px",
                  backgroundColor: themeStyle.primaryColor,
                  paddingLeft: "15px",
                }}
              ></div>
              <RightInView delay={timelineDelays[1]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: "18px",
                    color: "black",
                    paddingLeft: "15px",
                    textAlign: state.auth.isMobile ? "left" : "justify",
                    fontWeight: 500,
                  }}
                >
                  {props.subtitle}
                </div>
              </RightInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function FeatureCard(props) {
  const [zoom, zoomApi] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  return (
    <animated.div
      onMouseEnter={() => {
        zoomApi.start({
          from: {
            transform: "scale(1)",
          },
          to: {
            transform: "scale(1.05)",
          },
        });
      }}
      onMouseLeave={() => {
        zoomApi.start({
          from: {
            transform: "scale(1.05)",
          },
          to: {
            transform: "scale(1)",
          },
        });
      }}
      style={{
        cursor: "pointer",
        padding: "25px",
        paddingTop: "15px",
        borderRadius: "10px",
        width: "100%",
        height: "100%",
        backgroundImage: props.gradient,
        justifyContent: "space-between",
        alignItems: "flex-start",
        display: "flex",
        color: "#ddd",
        minHeight: props.minHeight == null ? "45vh" : props.minHeight,
        ...zoom,
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>{props.icon}</div>

        <div
          style={{
            marginTop: "20px",
            color: "white",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            fontSize: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              color: "white",
              fontWeight: 600,
              fontSize: "20px",
              marginTop: "15px",
              marginBottom: "15px",
            }}
          >
            {props.title}
          </div>
          {props.text}
        </div>
      </div>
    </animated.div>
  );
}

export function FeatureCardSmall(props) {
  const [zoom, zoomApi] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  return (
    <animated.div
      onMouseEnter={() => {
        zoomApi.start({
          from: {
            transform: "scale(1)",
          },
          to: {
            transform: "scale(1.05)",
          },
        });
      }}
      onMouseLeave={() => {
        zoomApi.start({
          from: {
            transform: "scale(1.05)",
          },
          to: {
            transform: "scale(1)",
          },
        });
      }}
      style={{
        cursor: "pointer",
        padding: "25px",
        paddingTop: "15px",
        borderRadius: "10px",
        width: "100%",
        height: "100%",
        backgroundImage: props.gradient,
        justifyContent: "space-between",
        alignItems: "flex-start",
        display: "flex",
        ...zoom,
      }}
    >
      <div>
        {props.icon}
        <div
          style={{
            color: "white",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            fontSize: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              color: "white",
              fontWeight: 600,
              fontSize: "20px",
              marginTop: "15px",
            }}
          >
            {props.title}
          </div>
        </div>
      </div>
    </animated.div>
  );
}

export function ThreeSideBySide(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];

  return (
    <div
      style={{
        width: "100vw",
        background: props.background == null ? "white" : props.background,
        paddingBottom: "100px",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid
            container
            spacing={props.spacing == null ? 10 : props.spacing}
            justifyContent={"flex-start"}
          >
            <Grid
              item
              md={4}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
                marginLeft: "-7.5px",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <img
                  style={{
                    width: "100%",
                    minHeight: props.image2 == null ? "0px" : "300px",
                    maxWidth: "500px",
                    objectFit: "cover",
                  }}
                  src={props.image2}
                ></img>
              </UpInView>

              <UpInView delay={timelineDelays[1]}>
                <div
                  style={{
                    marginTop: "50px",
                    textAlign: "left",
                    borderRadius: "25px",
                    fontSize: "26px",
                    color: "black",
                    fontWeight: 600,
                    lineHeight: "40px",
                    marginBottom: "25px",
                  }}
                >
                  {props.title1}
                </div>
              </UpInView>
              <UpInView delay={timelineDelays[2]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: "18px",
                    color: "black",
                    textAlign: "left",
                  }}
                >
                  {props.subtitle1}
                </div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
                marginLeft: "-7.5px",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <img
                  style={{
                    width: "100%",
                    minHeight: props.image1 == null ? "0px" : "300px",
                    maxWidth: "500px",
                    objectFit: "cover",
                  }}
                  src={props.image1}
                ></img>
              </UpInView>

              <UpInView delay={timelineDelays[1]}>
                <div
                  style={{
                    marginTop: "50px",
                    textAlign: "left",
                    borderRadius: "25px",
                    fontSize: "26px",
                    color: "black",
                    fontWeight: 600,
                    lineHeight: "40px",
                    marginBottom: "25px",
                  }}
                >
                  {props.title2}
                </div>
              </UpInView>
              <UpInView delay={timelineDelays[2]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: "18px",
                    color: "black",
                  }}
                >
                  {props.subtitle2}
                </div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
                minHeight: "50vh",
                marginLeft: "-7.5px",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <img
                  style={{
                    width: "100%",
                    minHeight: props.image3 == null ? "0px" : "300px",
                    maxWidth: "500px",
                    objectFit: "cover",
                  }}
                  src={props.image3}
                ></img>
              </UpInView>

              <UpInView delay={timelineDelays[1]}>
                <div
                  style={{
                    marginTop: "50px",
                    textAlign: "left",
                    borderRadius: "25px",
                    fontSize: "26px",
                    color: "black",
                    fontWeight: 600,
                    lineHeight: "40px",
                    marginBottom: "25px",
                  }}
                >
                  {props.title3}
                </div>
              </UpInView>
              <UpInView delay={timelineDelays[2]}>
                <div
                  style={{
                    borderRadius: "25px",
                    fontSize: "18px",
                    color: "black",
                  }}
                >
                  {props.subtitle3}
                </div>
              </UpInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function Gallery(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];
  const [activeIndex, setActiveIndex] = useState(240);

  // Safely handle gallery prop - ensure it's an array
  const gallery = Array.isArray(props.gallery) ? props.gallery : [];

  const zoomIns = useSprings(
    gallery.length,
    gallery.map((prop, index) => ({
      from: { transform: "scale(1)" },
      to: { transform: activeIndex == index ? "scale(1.05)" : "scale(1)" },
    }))
  );

  const navigate = useNavigate();

  return (
    <div
      style={{
        width: "100vw",
        paddingTop: "75px",
        background: "white",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid container spacing={5}>
            {gallery.map((gal1, index) => (
              <Grid
                item
                md={4}
                xs={12}
                sm={12}
                onClick={() =>
                  navigate("/leaders", {
                    state: {
                      image: gal1["image"],
                      title: gal1["title"],
                      subtitle: gal1["subtitle"],
                      content: gal1["content"],
                    },
                  })
                }
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "start",
                  minHeight: "50vh",
                }}
              >
                <UpInView delay={timelineDelays[index]}>
                  <animated.div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      ...zoomIns[index],
                    }}
                    onMouseEnter={() => {
                      setActiveIndex(index);
                    }}
                    onMouseLeave={() => {
                      setActiveIndex(240);
                    }}
                  >
                    <div
                      alt="Norway"
                      style={{
                        height: "50vh",
                        width: "100%",
                        borderRadius: "15px",
                        backgroundPosition: "center",
                        background:
                          "linear-gradient(0deg, rgba(0,0,0,0.9), rgba(2, 77, 194, 0.0), rgba(2, 77, 194, 0.0)), url('" +
                          gal1["image"] +
                          "')",
                        backgroundSize: "cover",
                        backgroundRepeat: "none",
                      }}
                    />
                    <div
                      style={{
                        borderTopRightRadius: "50px",
                        padding: "18px",
                        position: "absolute",
                        textAlign: "left",
                        bottom: 10,
                      }}
                    >
                      <div
                        style={{
                          fontSize: "25px",
                          color: "white",
                          fontWeight: 600,
                        }}
                      >
                        {gal1["title"]}
                      </div>
                      <div
                        style={{
                          fontSize: "18px",
                          color: "white",
                          fontWeight: "lighter",
                        }}
                      >
                        {gal1["subtitle"]}
                      </div>
                    </div>
                  </animated.div>
                </UpInView>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function Stats(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];
  const [activeIndex, setActiveIndex] = useState(240);
  const navigate = useNavigate();

  const zoomIns = useSprings(
    4,
    [1, 2, 3, 4].map((prop, index) => ({
      from: { transform: "scale(1)" },
      to: { transform: activeIndex == index ? "scale(1.05)" : "scale(1)" },
    }))
  );

  return (
    <div
      style={{
        width: "100vw",
        paddingTop: "75px",
        background: "white",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <Grid container spacing={5}>
            <Grid
              item
              md={3}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onClick={() => {
                    navigate("/about");
                  }}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    width: "100%",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",
                    minHeight:
                      props.minHeight == null ? "30vh" : props.minHeight,
                    ...zoomIns[0],
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      minHeight: "30vh",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "60px",
                        color: "white",
                      }}
                    >
                      300+
                    </div>

                    <div
                      style={{
                        marginTop: "20px",
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: "20px",
                          marginTop: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        EMPLOYEES
                      </div>
                      Our Workforce, globally distributed
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onClick={() => {
                    navigate("/about");
                  }}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    width: "100%",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",

                    minHeight:
                      props.minHeight == null ? "30vh" : props.minHeight,
                    ...zoomIns[0],
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      minHeight: "30vh",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "60px",
                        color: "white",
                      }}
                    >
                      4
                    </div>

                    <div
                      style={{
                        marginTop: "20px",
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: "20px",
                          marginTop: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        COUNTRIES
                      </div>
                      Our Presence across the globe
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onClick={() => {
                    navigate("/about");
                  }}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    width: "100%",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",
                    minHeight:
                      props.minHeight == null ? "30vh" : props.minHeight,
                    ...zoomIns[0],
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      minHeight: "30vh",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "60px",
                        color: "white",
                      }}
                    >
                      1000+
                    </div>

                    <div
                      style={{
                        marginTop: "20px",
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: "20px",
                          marginTop: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        PROJECTS
                      </div>
                      With 100% customer satisfaction
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              sm={12}
              style={{
                height: "100%",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <UpInView delay={timelineDelays[0]}>
                <animated.div
                  className={"anigrad"}
                  onClick={() => {
                    navigate("/about");
                  }}
                  onMouseEnter={() => {
                    setActiveIndex(0);
                  }}
                  onMouseLeave={() => {
                    setActiveIndex(10);
                  }}
                  style={{
                    cursor: "pointer",
                    paddingTop: "15px",
                    padding: "25px",
                    borderRadius: "10px",
                    width: "100%",
                    height: "100%",
                    backgroundImage: props.gradient,
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    display: "flex",
                    color: "#ddd",
                    borderRadius: "15px",
                    border: "2px solid grey",
                    minHeight:
                      props.minHeight == null ? "30vh" : props.minHeight,
                    ...zoomIns[0],
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      minHeight: "30vh",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "60px",
                        color: "white",
                      }}
                    >
                      400+
                    </div>

                    <div
                      style={{
                        marginTop: "20px",
                        color: "white",
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          color: "white",
                          fontWeight: 600,
                          fontSize: "20px",
                          marginTop: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        HIRINGS
                      </div>
                      Onboarding with our clients
                    </div>
                  </div>
                </animated.div>
              </UpInView>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
    </div>
  );
}

export function News(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 300, 600];
  const [activeIndex, setActiveIndex] = useState(240);
  const [show, setShow] = useState(false);

  // Safely handle gallery prop - ensure it's an array
  const gallery = Array.isArray(props.gallery) ? props.gallery : [];

  const zoomIns = useSprings(
    gallery.length,
    gallery.map((prop, index) => ({
      from: { transform: "translate(0px, 0px)" },
      to: {
        transform:
          activeIndex == index
            ? "translate(0px, -15px)"
            : "translate(0px, 0px)",
      },
    }))
  );

  const navigate = useNavigate();
  return (
    <div
      style={{
        width: "100vw",
        paddingTop: "75px",
        background: "white",
      }}
    >
      <Grid container>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          {show ? (
            <Grid container spacing={5}>
              {gallery.map((gal1, index) => (
                <Grid
                  item
                  md={3}
                  xs={12}
                  sm={12}
                  style={{
                    height: "100%",
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "start",
                    minHeight: "40vh",
                    borderRadius: "15px",
                  }}
                >
                  <UpInView delay={timelineDelays[index]}>
                    <animated.div
                      onClick={() => navigate("/" + gal1["page"])}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        ...zoomIns[index],
                      }}
                      onMouseEnter={() => {
                        setActiveIndex(index);
                      }}
                      onMouseLeave={() => {
                        setActiveIndex(240);
                      }}
                    >
                      <div
                        alt="Norway"
                        style={{
                          height: "40vh",
                          width: "100%",
                          backgroundPosition: "center",
                          background:
                            "linear-gradient(-180deg, rgba(0,0,0,0.9), rgba(0, 0,0, 0.4), rgba(2, 77, 194, 0.0)), url('" +
                            gal1["image"] +
                            "')",
                          backgroundSize: "cover",
                          backgroundRepeat: "none",
                          borderRadius: "15px",
                        }}
                      />
                      <div
                        style={{
                          borderTopRightRadius: "50px",
                          padding: "18px",
                          position: "absolute",
                          textAlign: "left",
                          top: 10,
                        }}
                      >
                        <div
                          style={{
                            fontSize: "25px",
                            color: "white",
                            fontWeight: 600,
                          }}
                        >
                          {gal1["title"]}
                        </div>
                        <div
                          style={{
                            fontSize: "18px",
                            color: "white",
                            fontWeight: "normal",
                          }}
                        >
                          {gal1["subtitle"]}
                        </div>
                      </div>
                    </animated.div>
                  </UpInView>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={5}>
              {Array.from(gallery)
                .splice(0, 8)
                .map((gal1, index) => (
                  <Grid
                    item
                    md={3}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "start",
                      minHeight: "40vh",
                      borderRadius: "15px",
                    }}
                  >
                    <UpInView delay={timelineDelays[index]}>
                      <animated.div
                        onClick={() => navigate("/" + gal1["page"])}
                        cdd
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          ...zoomIns[index],
                        }}
                        onMouseEnter={() => {
                          setActiveIndex(index);
                        }}
                        onMouseLeave={() => {
                          setActiveIndex(240);
                        }}
                      >
                        <div
                          alt="Norway"
                          style={{
                            height: "40vh",
                            width: "100%",
                            backgroundPosition: "center",
                            background:
                              "linear-gradient(-180deg, rgba(0,0,0,0.9), rgba(0, 0,0, 0.4), rgba(2, 77, 194, 0.0)), url('" +
                              gal1["image"] +
                              "')",
                            backgroundSize: "cover",
                            backgroundRepeat: "none",
                            borderRadius: "15px",
                          }}
                        />
                        <div
                          style={{
                            borderTopRightRadius: "50px",
                            padding: "18px",
                            position: "absolute",
                            textAlign: "left",
                            top: 10,
                          }}
                        >
                          <div
                            style={{
                              fontSize: "25px",
                              color: "white",
                              fontWeight: 600,
                            }}
                          >
                            {gal1["title"]}
                          </div>
                          <div
                            style={{
                              fontSize: "18px",
                              color: "white",
                              fontWeight: "normal",
                            }}
                          >
                            {gal1["subtitle"]}
                          </div>
                        </div>
                      </animated.div>
                    </UpInView>
                  </Grid>
                ))}
            </Grid>
          )}
        </Grid>
        <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
      </Grid>
      <div style={{ height: "100px", marginTop: "-50px" }}></div>
      <div
        class="button-box2"
        style={{ marginBottom: "50px" }}
        onClick={() => setShow(!show)}
      >
        <button class="ten">{show ? "Hide Items" : "Read More"} </button>
      </div>
    </div>
  );
}

export function Trust(props) {
  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: [
        {
          id: "item-1",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                border: "1px solid grey",

                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/logo1.png")} />
            </div>
          ),
        },
        {
          id: "item-2",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                border: "1px solid grey",

                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/logo2.png")} />
            </div>
          ),
        },
        {
          id: "item-3",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                border: "1px solid grey",

                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/logo3.png")} />
            </div>
          ),
        },
        {
          id: "item-4",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                border: "1px solid grey",

                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/logo4.png")} />
            </div>
          ),
        },
        {
          id: "item-5",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                border: "1px solid grey",

                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/logo5.png")} />
            </div>
          ),
        },
        {
          id: "item-6",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                border: "1px solid grey",

                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/logo6.png")} />
            </div>
          ),
        },
        {
          id: "item-7",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                border: "1px solid grey",

                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/logo7.png")} />
            </div>
          ),
        },
        {
          id: "item-8",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                border: "1px solid grey",

                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/logo8.jpg")} />
            </div>
          ),
        },
        {
          id: "item-9",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid grey",
              }}
            >
              <img
                style={{ width: "75%" }}
                src={require("../img/logo10.png")}
              />
            </div>
          ),
        },
        {
          id: "item-10",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid grey",
              }}
            >
              <img
                style={{ width: "75%" }}
                src={require("../img/ABSA.png")}
              />
            </div>
          ),
        },
        {
          id: "item-11",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid grey",
              }}
            >
              <img
                style={{ width: "75%" }}
                src={require("../img/CAPITEC.png")}
              />
            </div>
          ),
        },
        {
          id: "item-12",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid grey",
              }}
            >
              <img
                style={{ width: "75%" }}
                src={require("../img/FNB.png")}
              />
            </div>
          ),
        },
        {
          id: "item-12",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid grey",
              }}
            >
              <img
                style={{ width: "75%" }}
                src={require("../img/INVESTEC.png")}
              />
            </div>
          ),
        },
        {
          id: "item-13",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid grey",
              }}
            >
              <img
                style={{ width: "75%" }}
                src={require("../img/MOMENTUM.png")}
              />
            </div>
          ),
        },
        {
          id: "item-14",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid grey",
              }}
            >
              <img
                style={{ width: "75%" }}
                src={require("../img/RMB.png")}
              />
            </div>
          ),
        },
        {
          id: "item-15",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid grey",
              }}
            >
              <img
                style={{ width: "75%" }}
                src={require("../img/WESBANK.png")}
              />
            </div>
          ),
        },
      ],
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 2000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  const state = useSelector((state) => state);

  return (
    <div>
      <div
        style={{
          borderRadius: "25px",
          fontSize: state.auth.isMobile ? "30px" : "40px",
          color: themeStyle.primaryColor,
          fontWeight: 600,
          backgroundColor: "white",
          paddingBottom: "25px",
        }}
      >
        Our Partners
      </div>
      <div
        style={{
          marginLeft: "500px",
          width: "20vw",
          height: "30vh",
          marginBottom: "100px",
        }}
      >
        {carouselFragment}
      </div>
    </div>
  );
}
